import styled from 'styled-components';
import { themeColor } from '../../theme/colors';
import { smBold, xxsBold } from '../../theme/typography';
import { HudIcon } from '../../Icons/HudIcons';

export const Container = styled.div`
  min-width: 100px;
  flex: 1;

  display: flex;

  border-radius: 8px;
  border: 1px solid ${themeColor('strokePrimary')};
  background: ${themeColor('buttonBackground')};

  padding: 8px 12px;
  align-items: center;
  gap: 8px;

  cursor: pointer;
`;

export const TagsGroup = styled.div`
  flex: 1;
  display: flex;
  gap: 8px;
  flex-wrap: wrap;

  min-height: 24px;
`;

export const Tag = styled.div`
  ${xxsBold};
  display: flex;
  padding: 2px 6px 2px 10px;
  align-items: center;
  gap: 4px;
  color: ${themeColor('textPrimary')};
  cursor: initial;
  user-select: none;

  border-radius: 6px;
  border: 1px solid ${themeColor('strokePrimary')};
  background: ${themeColor('buttonBackground')};
  background: ${themeColor('buttonBackground')};
`;

export const Placeholder = styled.div`
  flex: 1;
  ${smBold};
  color: ${themeColor('textTertiary')};

  user-select: none;
`;

export const CloseIcon = styled(HudIcon).attrs({
  size: '18px',
})`
  cursor: pointer;
  user-select: none;
  color: ${themeColor('gray')};

  &:hover {
    color: ${themeColor('textPrimary')};
  }
`;

export const CaretIcon = styled(HudIcon).attrs({
  size: '14px',
})`
  cursor: pointer;
  user-select: none;
  color: ${themeColor('gray')};

  &:hover {
    color: ${themeColor('textPrimary')};
  }
`;
